export var sportClubStatsStartYear = 2024;
